var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserMgmt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon User Mgmt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-User-Mgmt",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "users",
    transform: "translate(3.000000, 4.000000)",
    stroke: "#3D4A68",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1818182,11.4545455 L10.1818182,10.1818182 C10.1818182,8.77600245 9.04217936,7.63636364 7.63636364,7.63636364 L2.54545455,7.63636364 C1.13963882,7.63636364 0,8.77600245 0,10.1818182 L0,11.4545455",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.09090909,
    cy: 2.54545455,
    r: 2.54545455
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,11.4545455 L14,10.1818182 C13.9991347,9.0218022 13.2140901,8.00909466 12.0909091,7.71909091",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54545455,0.0827272727 C10.671764,0.371108047 11.4595366,1.38599437 11.4595366,2.54863636 C11.4595366,3.71127836 10.671764,4.72616468 9.54545455,5.01454545",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMgmt);
export default __webpack_public_path__ + "static/media/userMgmt.688e5f4f7f1113293758c84a19ab1b87.svg";
export { ForwardRef as ReactComponent };